import type { Page } from '@/generated/graphql';

export const getPageUrl = (page: Page): string => {
  // '/home' is a special case as it is assigned to '/'
  if (page.slug === 'home') {
    return '/';
  }

  if (!page.parentPage) {
    return `/${page.slug || ''}`;
  }

  const parentPageUrl = getPageUrl(page.parentPage);
  const slug = page.slug ? `/${page.slug}` : '';

  return `${parentPageUrl}${slug}`;
};
